import { useEffect } from 'react';

import { Card, Col, Row, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { doRemoveRedirectToCompleteAccountAfterSubmit } from 'src/actions';
import { useAccountSelector } from 'src/hooks';
import { MButton } from 'src/lib';

import CircleProgressBar from '../../../../lib/Miscellaneous/CircleProgressBar';
import { SpaceWithBreakpoint } from '../../../../lib/SpaceWithBreakpoint/SpaceWithBreakpoint';

import * as Styles from './CompleteAccount.styles';

export const COMPLETE_ACCOUNT_PATH = 'completeAccount';

export const CompleteAccount = () => {
  const shouldRedirect = useSelector((state: any) => state.app.redirectToCompleteAccountAfterSubmit);

  const { account } = useAccountSelector();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onCompleteAccount = () => {
    window.gtag('event', 'complete_account');
    navigate(`/accounts/personal-information`);
  };

  const renderCardContent = () => {
    if (account?.accountId && account?.type.isEntity && !account?.isEntityAccountTypeActive) {
      return (
        <>
          <Col span={24} className={Styles.almostFinished}>
            <h1 data-testId={'summary-account-status-title'}>Your Account Status is Pending</h1>
            <Row>
              <Col span={24} data-testId={'summary-account-status-description'}>
                You can start viewing Offers now, but your account status must be &quot;Active&quot; before you can
                invest.
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <SpaceWithBreakpoint size={8}>
              <MButton
                onClick={() => navigate(`/accounts/${account?.id}/account-status`)}
                type='secondary'
                className={Styles.button}
                testId='summary-btn-account-status'>
                Account Status
              </MButton>
              <MButton onClick={() => navigate(`/offers`)} className={Styles.button} testId='summary-btn-view-offers'>
                View Offers
              </MButton>
            </SpaceWithBreakpoint>
          </Col>
        </>
      );
    }

    return (
      <>
        <Col span={24}>
          <CircleProgressBar percent={56} strokeWidth={5} />
        </Col>
        <Col span={24} className={Styles.almostFinished}>
          <h1 data-testId={'summary-account-status-title'}>Almost Finished ...</h1>
          <Row>
            <Col span={24} data-testId={'summary-account-status-description'}>
              You can start viewing Offers now, but in order to invest you need to complete the account set up.
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <SpaceWithBreakpoint size={8}>
            <MButton onClick={onCompleteAccount} className={Styles.button} testId='summary-btn-complete-account'>
              Complete Account
            </MButton>
            <MButton
              onClick={() => navigate(`/offers`)}
              type='secondary'
              className={Styles.button}
              testId='summary-btn-view-offers'>
              View Offers
            </MButton>
          </SpaceWithBreakpoint>
        </Col>
      </>
    );
  };

  useEffect(() => {
    if (shouldRedirect) {
      dispatch(doRemoveRedirectToCompleteAccountAfterSubmit());
    }
  }, []);

  return (
    <>
      <Row className={Styles.completeAccountContainer}>
        <Space size={24} direction='vertical' className={Styles.containerWrapper}>
          <Col className={Styles.alignCenter}>
            <span className={Styles.welcomeLabel} data-testId={'summary-welcome-title'}>
              Welcome!
            </span>
          </Col>
          <Col className={Styles.alignCenter}>
            <Space size={0} direction='vertical'>
              <span className={Styles.welcomeDescription} data-testId={'summary-description'}>
                Thank you for signing up to get access to some of the most exciting IPOs and other Offerings. As a
                registered user we may contact you by email with news and updates on Offerings.
              </span>
              <span className={Styles.welcomeDescription} hidden>
                If you wish to change this, please update your{' '}
                <a
                  onClick={() => alert('This feature is part of next iterations')}
                  className={Styles.communicationPreferencesLink}>
                  Communication Preferences.
                </a>
              </span>
            </Space>
          </Col>
          <Col className={Styles.accountOptions}>
            <Card className={Styles.cardContent}>
              <Row gutter={[, 40]} justify='center' align='middle'>
                {renderCardContent()}
              </Row>
            </Card>
          </Col>
        </Space>
      </Row>
    </>
  );
};
